import Button from '../components/Button';
import { useHistory } from 'react-router-dom';
import Typography from '../components/Typography';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  wrapperButtons: {
    marginTop: '70px',
    textAlign: 'center'
  },
  wrapper: {
    margin: '15px auto 40px'
  },
  button: {
    margin: '0 auto',
    width: '80%',
    fontSize: '16px',
    height: '56px'
  },
  buttonBack: {
    height: '56px',
    width: '80%',
    border: '0'
  }
});

export const ContactStep = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <Typography text='¿Necesitás ayuda?' />
      <Typography text='Atendemos tus dudas! Llamanos o Whatsapeanos!!!' variant='h3' />
      <div className={classes.wrapperButtons}>
        <div className={classes.wrapper}>
          <Typography text='Elvio' variant='h3' />
          <Button
            variant='outlined'
            text='(0261) 328-1511'
            className={classes.button}
            href={`https://api.whatsapp.com/send?phone=5492613281511`}
            target={'_blank'}
          />
        </div>
        <div className={classes.wrapper}>
          <Typography text='Leandro' variant='h3' />
          <Button
            variant='outlined'
            text='(0261) 590-1405'
            className={classes.button}
            href={`https://api.whatsapp.com/send?phone=5492615901405`}
            target={'_blank'}
          />
        </div>
        <Button
          variant='outlined'
          text='Volver'
          color='inherit'
          className={classes.buttonBack}
          onClick={() => history.goBack()}
        />
      </div>
    </>
  );
};
